import { StateValue } from "xstate";
import { AirPriceFreezeMachineContext } from "../../../../../types/airPriceFreeze";
import { AirPriceFreezeContext } from "./context";

export enum PriceFreezeLoadingState {
  fetchTripDetails = "fetchTripDetails",
  fetchOfferData = "fetchOfferData",
}

export enum AirPriceFreezeOfferState {
  loading = "loading",
  selectCustomOfferDuration = "selectCustomOfferDuration",
  customOfferGenerated = "customOfferGenerated",
  error = "error",
  validate = "validate",
}

export enum AirPriceFreezeCheckoutQueryParams {
  tripId = "tripId",
  fareId = "fareId",
  checkoutState = "checkoutState",
}

export type AirPriceFreezeStateWithoutValue = {
  context: AirPriceFreezeContext | AirPriceFreezeMachineContext;
};

export type AirPriceFreezeMachineStateWithoutValue = {
  context: AirPriceFreezeMachineContext;
};

export type AirPriceFreezeMachineState = {
  value: StateValue;
  context: AirPriceFreezeMachineContext;
};
